import { gql } from '../../../__generated__/graphql/catalog'

export const SYNC_RETURN_EXCHANGE_CART = gql(`
  mutation syncReturnExchangeCart($cartToken: String!) {
    syncReturnExchangeCart(loopCartToken: $cartToken) {
      cart {
        ...Cart
      }
      userErrors {
        code
        field
        message
      }
      warnings {
        code
        message
        target
      }
    }
  }
`)
